import script from "./DetachCounterpartyConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetachCounterpartyConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./DetachCounterpartyConfirmDropdown.vue?vue&type=style&index=0&id=69d59fa0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d59fa0"]])

export default __exports__